unloadQueuedActions